import * as Yup from 'yup';
import Button from "react-bootstrap/Button";
import { Formik, Form, Field, ErrorMessage } from 'formik';

import classNames from "classnames";
import { useSignIn } from "./SignInModal.hooks";
import { useCallback } from "react";

type SignInValues = { email: string };
type SignInFormikProps = {
  onSuccess: (email: string) => void;
};

const SignupSchema = Yup.object().shape({
  email: Yup.string().email('잘못된 이메일 입니다.').required('이메일을 입력해 주세요.'),
});

export const SignInFormik = ({ onSuccess }: SignInFormikProps) => {
  const signIn = useSignIn();
  const onSubmit = useCallback(
    async ({ email }: SignInValues, { setSubmitting, resetForm, setFieldError}) => {
      try {
        setSubmitting(true);
        await signIn(email);
        setSubmitting(false);
        resetForm();
        onSuccess(email);
      } catch (e) {
        setFieldError('email', e instanceof Error ? `${e.message}` : '오류가 발생했습니다.');
      }
    },
    [onSuccess, signIn],
  )
  return (
    <Formik
      initialValues={{ email: '' }}
      validationSchema={SignupSchema}
      onSubmit={onSubmit}
    >
      {({ errors, touched, values, isSubmitting }) => (
        <Form>
          <Field
            name="email"
            className={classNames('form-control', { 'is-invalid': touched.email && errors.email })}
            placeholder="abc@gmail.com"
          />
          <ErrorMessage component="div" className="invalid-feedback" name="email" />
          <p className="form-text">입력하신 이메일로 로그인 할 수 있는 링크를 보내드립니다.</p>
          <Button variant="primary" type="submit" disabled={isSubmitting || !!errors.email || !values.email} className="d-block ms-auto">
            {isSubmitting ? '전송중' : '확인'}
          </Button>
        </Form>
      )}
    </Formik>
  );
};
